
export default {
    name: 'param-taux-assurance',
    components: {},
    props: [],
    data() {
        return {
            taux_is_loading: true,
            taux_is_empty: false,
            save_loading: false,

            fields: [
				'champ', { key: 'actions', label: 'Action.s' }
			],

			filter: "",
			tableIsBusy: true,
			perPage: 10,
			currentPage: 1,

            champs: {
                data_type: 'taux_assurance',
                champ: ''
            }
        }
    },

    computed: {
        champ_taux_assurance() {
			return this.$store.getters["champ_taux_assurance"];
		},

        rows() {
            return this.champ_taux_assurance.length;
        },
    },

    mounted() {
        this.getListeChampTauxAssurance(0)
    },

    methods: {
        getListeChampTauxAssurance(assurance_id) {
            this.taux_is_loading = true
			this.$store.dispatch("getChampsTauxAssurance", assurance_id).then(() => {
                if (this.champ_taux_assurance.length > 0) {
                    this.taux_is_empty = false
                } else {
                    this.taux_is_empty = true
                }
                this.taux_is_loading = false
            })
		},

        async submit() {
            const isValid = await this.$refs.taux_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            this.$store.dispatch('saveTauxChamp', this.champs).then((response) => {
                if (response > 0) {
                    this.successToast("Champ ajouté avec succès")

                    this.champs = {
                        data_type: 'taux_assurance',
                        champ: ''
                    }

                    this.getListeChampTauxAssurance(0)
                    this.$refs.taux_form.reset()
                    this.$refs.modal_taux.click()
                }

                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
            })
        }
    }
}